import { markOmniCineRouteIntent } from "@/lib/omniCineRouteIntent";

let omnicineRoutePromise: Promise<typeof import("@/pages/OmniCine")> | null = null;
let omnicineWarmChunksPromise: Promise<unknown> | null = null;

function warmOmniCineChunks(): Promise<unknown> {
  if (!omnicineWarmChunksPromise) {
    omnicineWarmChunksPromise = Promise.all([
      import("@/components/OmniCine/Timeline/TimelineShell"),
      import("@/components/OmniCine/Inspector/RightPanel"),
      import("@/components/OmniCine/Timeline/CommandPalette"),
    ]);
  }

  return omnicineWarmChunksPromise;
}

export function prefetchOmniCineRoute(options?: {
  markIntent?: boolean;
}): Promise<typeof import("@/pages/OmniCine")> {
  if (options?.markIntent !== false) {
    markOmniCineRouteIntent();
  }

  if (!omnicineRoutePromise) {
    omnicineRoutePromise = import("@/pages/OmniCine");
    void warmOmniCineChunks();
  }

  return omnicineRoutePromise;
}

export function scheduleOmniCinePrefetch(): void {
  if (typeof window === "undefined") return;

  // Keep dev startup focused on the active route. Auto-warming OmniCine is
  // useful in built/preview environments but adds avoidable transform churn
  // during Vite dev boot.
  if (import.meta.env.DEV) return;

  if ("requestIdleCallback" in window) {
    (window as Window & {
      requestIdleCallback: (callback: () => void, options?: { timeout: number }) => number;
    }).requestIdleCallback(() => {
      void prefetchOmniCineRoute({ markIntent: false });
    }, { timeout: 1500 });
    return;
  }

  globalThis.setTimeout(() => {
    void prefetchOmniCineRoute({ markIntent: false });
  }, 450);
}